import { QuoteRealtimeForm } from './QuoteRealtimeForm';
import { connectQuoteRealtimeForm } from './QuoteRealtimeForm.connect';

export const ConnectedQuoteRealtimeForm = connectQuoteRealtimeForm(QuoteRealtimeForm);
